/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 22
// module chunks = 0